import React from "react";
import { Link } from "react-router-dom";

import { NumberField } from "react-admin";

import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { LowInventoryIcon } from "../../../components/common/LowInventoryIcon";
import { accountNameRenderer } from "../../../components/common/AccountNameRenderer";

import { isAuthorized } from "../../../utils/appUtils";
import { AclType } from "../../../utils/constants";
import { getTotalQuantityAvailable } from "./ProductUtils";

const useAsideStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("sm")]: {
      width: "18em",
      minWidth: "18em",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0.5),
      overflow: "initial",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  status: {
    marginTop: theme.spacing(0.3),
  },
}));

export const ProductEditAside = ({
  backPath,
  history,
  record,
  account,
  ...props
}) => {
  const classes = useAsideStyles();
  const linkBackPath = backPath
    ? [...backPath, props.location.pathname]
    : [props.location.pathname];

  if (!record) return null;
  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container direction="column" spacing={1}>
          {account?.businessName && (
            <Grid item xs={12}>
              <Typography variant="overline" color="secondary">
                Account:
              </Typography>
              <br />
              {isAuthorized(AclType.ACCOUNTS) ? (
                <Link
                  to={{
                    pathname: `/accounts/${account.id}`,
                    state: { backPath: linkBackPath },
                  }}
                >
                  <Typography variant="body2" color="primary">
                    {accountNameRenderer(account)}
                  </Typography>
                </Link>
              ) : (
                <Link
                  to={{
                    pathname: `/accounts/${account.id}/show`,
                    state: { backPath: linkBackPath },
                  }}
                >
                  <Typography variant="body2" color="primary">
                    {account.businessName}
                  </Typography>
                </Link>
              )}
            </Grid>
          )}
          {record?.lowInventoryAlert && (
            <Grid item xs={12}>
              <Typography variant="overline" color="secondary">
                Status:
              </Typography>
              <br />
              <Grid container direction="row">
                <Grid item xs={2}>
                  <LowInventoryIcon record={record} />
                </Grid>
                <Grid item xs={10} className={classes.status}>
                  Low Inventory
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              On Hand:
            </Typography>
            <br />
            <NumberField source="totalQuantityOnHand" record={record} />{" "}
            {record.defaultUOM}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Committed:
            </Typography>
            <br />
            <NumberField source="totalQuantityCommitted" record={record} />{" "}
            {record.defaultUOM}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Available:
            </Typography>
            <br />
            {getTotalQuantityAvailable(record)} {record.defaultUOM}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
